export default "__VITE_ASSET__DerJMbnc__"